import { lazy } from 'react';
import DefaultLayout from "../common-layouts/DefaultLayout";

const Home = lazy(() => import("../components/home/Home"));
const NotFound = lazy(() => import("../components/NotFound"));

export const allRoute = [
  { path: "/", layout: DefaultLayout, component: Home },
  { path: "*", layout: DefaultLayout, component: NotFound }
];